/* ======================================================
 * MBSelect DROPDOWN + GSAP SCROLL (FINAL, SCROLL-SAFE)
 * ====================================================== */

document.addEventListener('click', (e) => {
    const select = e.target.closest('.MBSelect--services');

    // CLICK OUTSIDE → CLOSE
    if (!select) {
        document.querySelectorAll('.MBSelect--services').forEach(sel => {
            sel.dataset.state = 'closed';
            sel.querySelector('.MBSelect__btn')
                ?.setAttribute('aria-expanded', 'false');
        });
        return;
    }

    const btn = select.querySelector('.MBSelect__btn');
    const valueEl = select.querySelector('.MBSelect__value');

    /* -----------------------------
       BUTTON CLICK → TOGGLE
    ----------------------------- */
    if (e.target.closest('.MBSelect__btn')) {
        e.stopPropagation(); // ONLY stop outside-close

        const isOpen = select.dataset.state === 'open';

        document.querySelectorAll('.MBSelect--services').forEach(sel => {
            sel.dataset.state = 'closed';
            sel.querySelector('.MBSelect__btn')
                ?.setAttribute('aria-expanded', 'false');
        });

        select.dataset.state = isOpen ? 'closed' : 'open';
        btn.setAttribute('aria-expanded', String(!isOpen));
        return;
    }

    /* -----------------------------
       OPTION CLICK → SCROLL
    ----------------------------- */
    const opt = e.target.closest('.MBSelect__item');
    if (opt) {
        e.stopPropagation();

        const sectionKey = opt.getAttribute('data-section');
        const target = document.querySelector(
            `.tp-inner-service-item[data-section="${sectionKey}"]`
        );

        // update label
        valueEl.textContent = opt.textContent.trim();

        // close dropdown
        select.dataset.state = 'closed';
        btn.setAttribute('aria-expanded', 'false');

        // GSAP scroll (mobile only)
        if (
            window.matchMedia('(max-width: 1200px)').matches &&
            target &&
            window.gsap
        ) {
            gsap.to(window, {
                scrollTo: {
                    y: target,
                    offsetY: 120,
                },
                duration: 0.4,
                ease: 'power2.out',
            });
        }
    }
});